import React from 'react';
import { HeaderB } from '../../components/landingB/HeaderB';
import { HeroB } from '../../components/landingB/HeroB';
import { LifeSequence } from '../../components/landingB/LifeSequence';
import { MeetCampus } from '../../components/landingB/MeetCampus';
import { DayTimeline } from '../../components/landingB/DayTimeline';
import { ProductStripes } from '../../components/landingB/ProductStripes';
import { OneAccount } from '../../components/landingB/OneAccount';
import { PersonalizationB } from '../../components/landingB/PersonalizationB';
import { FinalCTAB } from '../../components/landingB/FinalCTAB';
import { FooterB } from '../../components/landingB/FooterB';

/**
 * Campuzon homepage — experience B, "the digital world of campus life".
 *
 * A complete, self-contained homepage: its own navigation (which begins over
 * the hero photograph) and its own footer, so it shares no chrome with the
 * other experience and cannot inherit or disturb it. Everything it renders
 * comes from the same product data the rest of Campuzon uses.
 *
 * The colour rhythm is deliberate and carries the reading:
 *   photography → warm white → photography → white → deep green → white → green
 */
export function LandingB() {
  return <div data-campuzon-experience="design-b" className="min-h-screen w-full bg-surface" data-id="element-9166" data-mp="3v1av510vxrvk">
      <a href="#homepage-main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-ink focus:px-4 focus:py-2 focus:text-body-sm focus:text-white" data-id="element-9167" data-mp="3q0dewtzfr7wp">
        Skip to content
      </a>

      <HeaderB data-id="element-9168" data-mp="hldazwqqvg5p" />

      <main id="homepage-main" data-id="element-9169" data-mp="hlv1sdun1268">
        <HeroB data-id="element-9170" data-mp="hl3km81sf6zh" />
        <LifeSequence data-id="element-9171" data-mp="hnpnhudqgybd" />
        <MeetCampus data-id="element-9172" data-mp="dk06bpze1j0d" />
        <DayTimeline data-id="element-9173" data-mp="djrodjoernib" />
        <ProductStripes data-id="element-9174" data-mp="dlb5fchw22l5" />
        <OneAccount data-id="element-9175" data-mp="dm4ggpnvre93" />
        <PersonalizationB data-id="element-9176" data-mp="rjsrz6w2591h" />
        <FinalCTAB data-id="element-9177" data-mp="riztet795puf" />
      </main>

      <FooterB data-id="element-9178" data-mp="rk2h6s9a3c64" />
    </div>;
}